// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './mobile-fix.css';
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { TenantSettingsProvider } from './contexts/TenantSettingsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantSettingsProvider>
          <App />
        </TenantSettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
